
import Vue from 'vue'

export default Vue.extend({
  data: () => ({
    appVersion: process.env.VUE_APP_VERSION,
  }),
})
